module.exports = __webpack_public_path__ + "static/background-header-reference-e11ec501209a9b3f69cb333bc0453187.png";